import { ContentLink, LinkableContent } from "@robe/client/xcore-ui";
import { Box, Flex, Grid, Img, Link, Typography } from "@xcorejs/ui";
import ApplicationPickerIcon from "components/Icons/12/application-picker.svg";
import useDropdown from "design-system/xcore/Dropdown";
import IconBox from "design-system/xcore/IconBox";
import { useLayout } from "xcore";

const ApplicationPicker = () => {
  const { subheader, stringify, general, image: imageFunc } = useLayout();

  const { OnClick } = useDropdown({
    closeOnMouseLeave: true,
    position: "absolute",
    locationY: "top",
    locationX: "right",
    _firstDropdownProps: {
      left: 0,
      marginLeft: "-2rem",
      top: "100%",
      maxWidth: "none",
    },
  });

  return (
    <OnClick
      props={{
        children: (
          <Box
            _after={{
              content: '""',
              display: "flex",
              width: "200vw",
              left: "-50%",
              top: "0",
              height: "200vh",
              position: "fixed",
              pointerEvents: "none",
            }}
          >
            <Grid
              columns="repeat(3, 33rem)"
              rows="repeat(3, minmax(min-content, 20rem))"
              height="calc(100vh - 14rem)"
              maxHeight="60rem"
              position="relative"
              zIndex={1004}
            >
              {subheader.applicationPicker.values?.applications?.map((app, i) => {
                const iconUrl = app.icon ? imageFunc(app.icon) : null;
                const image = app.image ? imageFunc(app.image) : null;

                if (!app.relation?.slug || !app.relation?.type) {
                  return null;
                }

                return (
                  <ContentLink
                    style={{ justifyContent: "center", width: "100%", height: "100%" }}
                    key={i}
                    content={app.relation as LinkableContent}
                  >
                    <Flex
                      {...(image && { background: `#1e1e1e url('${image}') center center` })}
                      backgroundSize="cover"
                      role="group"
                      alignItems="center"
                      flexDirection="column"
                      justifyContent="center"
                      filter="grayscale(100%) brightness(2.5)"
                      transform="translateZ(0) scale(1.0, 1.0)"
                      transition="filter 300ms"
                      width="100%"
                      height="100%"
                      _hover={{ filter: "grayscale(0%) brightness(1) blur(0.2px)" }}
                      overflow="hidden"
                      backface-visibility="hidden"
                    >
                      {iconUrl && (
                        <Img
                          src={iconUrl}
                          opacity={0}
                          transition="opacity 300ms, margin 300ms"
                          width="3.2rem"
                          height="3.2rem"
                          _groupHover={{
                            opacity: 1,
                            mb: "2rem",
                          }}
                        />
                      )}
                      <Typography
                        v="h4"
                        textTransform="uppercase"
                        fontFamily="avenir"
                        fontSize="1.5rem"
                        fontWeight={600}
                        lineHeight="2rem"
                        color="white"
                      >
                        {stringify(app.relation.values?.thumbnailTitle)
                          ? stringify(app.relation.values?.thumbnailTitle)
                          : stringify(app.relation.title)}
                      </Typography>
                    </Flex>
                  </ContentLink>
                );
              })}
            </Grid>
          </Box>
        ),
      }}
    >
      {(active) => (
        <Link
          type="simple"
          as="a"
          display="flex"
          alignItems="center"
          height="4.6rem"
          px="2rem"
          _hover={{ bg: "#fff", color: "robe" }}
          transform="translateX(-2rem)"
          fontSize={{ _: "1.3rem", lg: "1.4rem" }}
          fontWeight={600}
          lineHeight="2.1rem"
          color={active ? "primary" : "lightGray"}
          transition="color 300ms, background 300ms"
          background={active ? "#fff" : undefined}
          zIndex={active ? 11000 : 10}
          position="relative"
          whiteSpace="nowrap"
        >
          <IconBox width="2.4rem" minWidth="2.4rem" height="2.4rem" icon={<ApplicationPickerIcon />} mr="1rem" />
          {stringify(general.values.appPicker)}
        </Link>
      )}
    </OnClick>
  );
};

export default ApplicationPicker;
